module.exports = __webpack_public_path__ + "static/media/logo.f3b1b96f.png";